/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-04
 */

import React from 'react'
import { connect } from 'dva'
import moment from 'moment'
import { framework_tool, component_tool, utils_tool } from '../../../../tool'

let { Session, isType } = utils_tool;
let { WizContainer, WizAvatarUpload, ossFileUtils } = framework_tool
let {
  WizCustomSteps,
  WizForm,
  WizRow,
  WizCol,
  WizButton,
  WizInputNumber,
  WizIcon,
  WizCheckbox,
  WizDatePicker,
  WizTooltip,
  WizRadio,
  Wizmessage,
} = component_tool
import { modelUtils } from '@/utils'
import ExamCategorySelect from '../examCategorySelect/examCategorySelect'
import examInfo from "../examInfo/examInfo";
import { WizTableForm } from '@/containers/common'
import { Card } from "antd";
import './index.less'

const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1, roleConfig: "teacherRole" } })


const getParamRecord = (history) => {
  let record = {}
  if (history.location) {
    if (history.location.pathname === '/online/exam/examDetailUpd') {
      if (history.location && history.location.record) {
        record = history.location.record
        Session.set('examDetailInfo', record)
      } else {
        record = Session.get('examDetailInfo') || {}
      }
    }
    if (history.location.pathname === '/online/exam/examDetailAdd') {
      if (history.location.record) {
        record = history.location.record
        record.channelType = record.channelType || 'create'
        Session.set('examDetailAdd', record)
      } else {
        record = Session.get('examDetailAdd') || {}
      }
    }
  }
  return record
}


class ExamDetail extends WizContainer {
  componentName = 'examDetail'

  constructor(props) {
    super(props)
    let record = getParamRecord(props.history);
    let categoryTypeName = "";
    let faceChecked = false;
    let faceDisabled = false;
    if (record) {
      let { categoryType, face, examType } = record;
      if (categoryType) {
        categoryTypeName = categoryType;
      }
      if (face === 1) {
        faceChecked = true
      }
      if (examType !== 0 || categoryType !== '普通考试') {
        faceDisabled = true;
      }
      if (record['status'] > 0 && !this.copyExam) {
        faceDisabled = true;
      }
    }
    this.state = {
      record: record,
      faceChecked: faceChecked,
      faceDisabled: faceDisabled,
      categoryTypeName: categoryTypeName,
      faceTimesKey: new Date().getTime(),
      totalScore: record['totalScore'],
    }
    this.checks = {
      shuffle: { title: '试题顺序打乱', tips: '题序随机生成，防止考试作弊。(仅针对固定考题出卷试卷)' },
      optionRandom: { title: '选择题选项打乱', tips: '单选及多选题选项顺序随机生成，防止考试作弊。' },
      face: { title: '身份验证', tips: '考试时进行身份验证，防止考生替考。勾选后必须进行考前认证，考中认证可选' },
      examBeforeAuth: { title: '支持考前认证', tips: '身份验证勾选后，考前验证为必选项，将在进入考试后立即进行身份验证' },
      doingAuth: { title: '支持考中认证', tips: '身份验证勾选后，考中验证为可选项，设置后可在考试过程中进行身份验证' },
      autoMark: { title: '系统自动批阅' },
      showScore: { title: '批阅后允许学员查看分数', tips: '批阅后允许学员查看考试得分。' },
      showResult: { title: '批阅后允许学员查看通过状态', tips: '批阅后允许学员查看考试是否通过。' },
      showHistory: { title: '批阅后允许学员查看答卷记录', tips: '批阅后允许学员查看已提交的答卷记录。' },
      showAnswer: { title: '允许学员查看正确答案', tips: '学员查看答卷记录时，允许查看题目正确答案信息。' },
      resolve: { title: '允许学员查看答案解析', tips: '学员查看答卷记录时，允许查看题目答案解析信息。' }
    }
    this._examId = record['id']
    this.copyExam = record['copyExam'] || false
    this._copyExamId = record['id']

    this._type = record['channelType'] //来源渠道类型
    this.initialValue = record
    this.resetTime = new Date().getTime()
  }

  _renderCheckRow(key, getFieldDecorator) {
    // autoMark 系统自动批阅 如果编辑时,只有为草稿状态(status = 0)才可更改
    let disabled = false
    if (key === 'autoMark' && this.state.record['status'] >= 1 && !this.copyExam) {
      disabled = true
    }
    if (key === 'face' && this.state.record['status'] > 0 && !this.copyExam) {
      disabled = true
    }
    return (
      <WizRow>
        <WizCol>
          {
            getFieldDecorator(key, { initialValue: (key === 'examBeforeAuth' ? true : this.state.record[key]) })(
              <WizCheckbox key={this.resetTime + key} title={this.checks[key].title}
                defaultChecked={key === 'examBeforeAuth' ? true : this.state.record[key]}
                disabled={key === 'examBeforeAuth' ? true : disabled}>
                {this.checks[key].title}
              </WizCheckbox>
            )
          }
          {this._renderCheckTips(this.checks[key].tips)}
        </WizCol>
      </WizRow>
    )
  }

  _renderCheckRowFace(key, getFieldDecorator) {
    return (
      <WizRow key={'face_' + this.state.faceTimesKey}>
        <WizCol>
          {
            getFieldDecorator(key, { initialValue: (key === 'examBeforeAuth' ? true : this.state.record[key]) })(
              <WizCheckbox key={this.resetTime + key} title={this.checks[key].title}
                defaultChecked={this.state.faceChecked}
                disabled={this.state.faceDisabled}
              >
                {this.checks[key].title}
              </WizCheckbox>
            )
          }
          {this._renderCheckTips(this.checks[key].tips)}
        </WizCol>
      </WizRow>
    )
  }

  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips}>
          <WizIcon type='question-circle-o' />
        </WizTooltip>
      )
    }
  }



  //讲师验证
  lecturesValidator = (rule, value, callback) => {
    if (value.length === 0) {
      wizNotice.warn('请选择讲师')
      callback('请选择讲师')
    }
    if (value && value.length > 5) {
      wizNotice.warn('讲师最多选择5个')
      callback('讲师最多选择5个')
    }
    callback();
  }

  //认证次数校验
  authCountValidator = (rule, value, callback) => {
    let form = rule._form;
    if (form) {
      let { getFieldValue } = form
      let doingAuth = getFieldValue('doingAuth');
      if (doingAuth != null && doingAuth != undefined && doingAuth === 1) {
        if (value === null) {
          wizNotice.warn('请输入验证次数');
          callback('请输入验证次数');
        } else if (value != null && value <= 0) {
          wizNotice.warn('验证次数不能小于1次');
          callback('验证次数不能小于1次');
        }
      }
    }
    callback();
  }

  //认证时间校验
  authTimesValidator = (rule, value, callback) => {
    let form = rule._form;
    if (form) {
      let { getFieldValue } = form
      let doingAuth = getFieldValue('doingAuth');
      //考试时长
      let limitMinutes = getFieldValue('limitMinutes');
      if (doingAuth != null && doingAuth != undefined && doingAuth === 1) {
        if (limitMinutes != null && limitMinutes > 0) {
          if (value === null) {
            wizNotice.warn('请输入间隔时间');
            callback('请输入间隔时间');
          } else if (value != null && value < 5) {
            wizNotice.warn('间隔时间不能小于5分钟');
            callback('间隔时间不能小于5分钟');
          } else if (limitMinutes != null && limitMinutes < value) {
            wizNotice.warn('输入间隔时间不能超过考试时长');
            callback('输入间隔时间不能超过考试时长');
          }
        } else if (value === null || value === undefined) {
          wizNotice.warn('请先输入考试时长，之后再输入间隔时间');
          callback('请先输入考试时长，之后再输入间隔时间');
        }
      }
    }
    callback();
  }

  // 选择讲师
  _renderTeacherList(form) {
    let { getFieldValue, getFieldDecorator, setFieldsValue } = form
    let { record } = this.state
    let checkContainsSubjective = getFieldValue('containsSubjective')
    return (

      checkContainsSubjective === 0 ? getFieldDecorator('personIds', {
        initialValue: record['teacherList'] ? record['teacherList'].map(e => e.personId) : [],
        rules: [
          /* {
            validator: this.lecturesValidator
          }, */
          { required: true, message: '请选择批阅人' }
        ],
      })(<WizRow type='flex'>
        <WizCol>安排批阅人：</WizCol>
        <WizCol span={18}>
          <WizTableForm
            {...userConfig}
            initRows={record['teacherList'] || []}
            value={record['teacherList'] ? record['teacherList'].map(e => e.personId) : []}
            onChange={(e) => { setFieldsValue({ personIds: e }) }}
          ></WizTableForm>
        </WizCol>
      </WizRow>) : null

    )
  }

  // 主观题radio
  _renderContainsSubjective(form) {
    let { getFieldValue, getFieldDecorator } = form
    let { record } = this.state
    let checkAutoMark = getFieldValue('autoMark')
    let disabled = record['status'] >= 1 && !this.copyExam // 只有非草稿状态,复制才开放radio
    return (
      checkAutoMark ?
        getFieldDecorator('containsSubjective', {
          initialValue: record['containsSubjective'] === undefined ? 1 : record['containsSubjective'],
        })(
          <WizRadio.Group disabled={disabled}>
            <WizRadio value={1}>包括主观题</WizRadio>
            <WizRadio value={0}>不包括主观题</WizRadio>
          </WizRadio.Group>
        ) : null
    )
  }

  // 人脸认证radio
  _renderFaceAuth(form) {
    let { getFieldValue, getFieldDecorator } = form
    let { record } = this.state
    let checkFace = getFieldValue('face');
    let key = 'doingAuth';
    let disabled = (record['status'] !== 0 && record['status'] !== undefined && record['status'] !== null) && !this.copyExam // 只有发布状态,同时不是复制状态才禁用radio
    // 是否显示考中认证配置,如果没有获取到form中的键值,从record取,存在且为1视为选中,其它清空为未选中
    let showMiddleCfg = getFieldValue(key) === undefined ? this.state.record[key] && this.state.record[key] == 1 ? true : false : form.getFieldValue(key)
    return (
      checkFace ?
        (<Card bodyStyle={{ paddingTop: 15 }}>
          {this._renderCheckRow('examBeforeAuth', getFieldDecorator)}
          <WizRow style={{ marginTop: 15, marginBottom: 10 }}>
            <WizCol>
              {
                getFieldDecorator(key, { initialValue: this.state.record[key] })(
                  <WizCheckbox disabled={disabled} key={this.resetTime + key} title={this.checks[key].title}
                    defaultChecked={this.state.record[key] === null || this.state.record[key] === undefined ? 0 : this.state.record[key]}
                  >
                    {this.checks[key].title}
                  </WizCheckbox>
                )
              }
              {this._renderCheckTips(this.checks[key].tips)}
            </WizCol>
          </WizRow>
          {
            showMiddleCfg ?
              <div className='intermediate-certification' style={{ marginTop: 15, marginBottom: 10 }}>
                <div className='intermediate-certification-row'>
                  <div className='intermediate-certification-row-title'>验证次数:</div>
                  <div className='intermediate-certification-row-input'>
                    {
                      getFieldDecorator('authenticationCount', {
                        rules: [
                          {
                            validator: this.authCountValidator, _form: form
                          }],
                        initialValue: (record['authenticationCount'] === undefined || record['authenticationCount'] === null || record['authenticationCount'] <= 0) ? null : record['authenticationCount'],
                      })(
                        <WizInputNumber
                          key={'authenticationCount1'}
                          placeholder={'请输入'}
                          disabled={disabled}
                          min={1}
                          max={3}
                          precision={0}
                        />
                      )
                    }
                  </div>
                </div>
                <div className='intermediate-certification-row'>
                  <div className='intermediate-certification-row-title'>间隔时间:</div>
                  <div className='intermediate-certification-row-input'>
                    {
                      getFieldDecorator('spaceTime', {
                        rules: [
                          {
                            validator: this.authTimesValidator, _form: form
                          }],
                        initialValue: (record['spaceTime'] === undefined || record['spaceTime'] === null || record['spaceTime'] <= 0) ? null : record['spaceTime'],
                      })(
                        <WizInputNumber
                          key={'spaceTime1'}
                          placeholder={'请输入'}
                          disabled={disabled}
                          min={5}
                          max={9999}
                          precision={0}
                        />
                      )
                    }
                  </div>
                  <div className='intermediate-certification-row-other'>
                    <span className='company'>分钟</span>
                    <WizTooltip title='最低为5分钟，间隔时间应小于考试时长'>
                      <WizIcon type='question-circle-o' />
                    </WizTooltip>
                  </div>
                </div>
              </div>
              :
              null
          }
        </Card>) : null
    )
  }

  _columns() {
    const { record, totalScore } = this.state
    const dateFormat = 'YYYY-MM-DD HH:mm:ss'
    let { categoryType, categoryTypeId, scoreRule } = record
    let selects = categoryTypeId ? [{
      label: categoryType,
      title: categoryType,
      key: categoryTypeId
    }] : []
    scoreRule = scoreRule ? scoreRule : 0
    return [
      {
        title: '考试名称',
        name: 'title',
        formItem: {
          maxLength: 50,
          rules: [{ required: true, message: '请输入考试名称' }]
        }
      },
      {
        title: '考试分类',
        name: 'categoryTypeId',
        formItem: {
          type: 'diy',
          selects: selects,
          disabled: this.state.record['status'] > 0 && !this.copyExam,
          diy: ExamCategorySelect,
          rules: [{ required: true, message: '请选择考试分类' }],
          onChangeRowMap: data => {
            if (data && isType(data, 'Object')) {
              let { title } = data;
              let examType = this.refs.form.getFieldValue('examType');
              if (examType !== 0 || title !== '普通考试') {
                this.setState({ categoryTypeName: title, faceChecked: false, faceDisabled: true, faceTimesKey: new Date().getTime() });
                this.refs.form.setFieldsValue({
                  face: 0
                });
              } else {
                this.setState({ categoryTypeName: title, faceDisabled: false, faceTimesKey: new Date().getTime() });
              }
            } else {
              this.setState({ categoryTypeName: '', faceChecked: false, faceDisabled: true, faceTimesKey: new Date().getTime() });
              this.refs.form.setFieldsValue({
                face: 0
              });
            }
          },
        }
      },
      {
        title: '考试类型',
        name: 'examType',
        formItem: {
          type: 'select',
          initialValue: 0,
          radioStyle: {
            display: 'block',
            height: '35px',
            lineHeight: '35px'
          },
          disabled: this.state.record['status'] > 0 && !this.copyExam,
          dict: [
            { code: 0, codeName: '独立考试' },
            { code: 1, codeName: '课程考试' }
          ],
          rules: [{ required: true, message: '请选择考试类型' }],
          onChange: (form, value, e) => {
            let categoryTypeName = this.state.categoryTypeName;
            if (value !== 0 || categoryTypeName !== '普通考试') {
              this.setState({ faceChecked: false, faceDisabled: true, faceTimesKey: new Date().getTime() });
              this.refs.form.setFieldsValue({
                face: 0
              });
            } else {
              this.setState({ faceDisabled: false, faceTimesKey: new Date().getTime() });
            }
          }
        }
      },
      {
        title: '试卷总分',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            return (
              <div style={{ paddingLeft: 10 }}>{(totalScore && totalScore <= 0) ? '-' : totalScore}
                <WizTooltip title={'根据试题安排情况，自动计算试卷总分。'}>
                  <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                </WizTooltip>
              </div>
            )
          }
        }
      },
      {
        title: '通过分数',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('passScore', {
                      rules: [{ required: true, message: '请输入通过分数' }],
                      initialValue: record['passScore']
                    })(
                      <WizInputNumber min={0} max={999.5} />
                    )
                  }
                </WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'请输入大于0且小于等于试卷总分的数值。'}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '成绩规则',
        name: 'scoreRule',
        formItem: {
          type: 'custom',
          render: (data, form) => {
            const { getFieldDecorator } = form
            const radioStyle = {
              alignItems: 'left',
              display: 'block',
              height: '35px',
              lineHeight: '35px'
            }
            return (
              <>
                {
                  getFieldDecorator('scoreRule', {
                    rules: [{
                      required: true,
                      message: '请选择成绩规则'
                    }],
                    initialValue: scoreRule
                  })(<WizRadio.Group defaultValue={scoreRule}>
                    <WizRadio value={0} style={radioStyle}>以学员成绩的最高分计算考试通过状态</WizRadio>
                    <WizRadio value={1} style={radioStyle}>以学员成绩的平均分计算考试通过状态</WizRadio>
                  </WizRadio.Group>)
                }
              </>
            )
          }
        }
      },

      {
        title: '开始时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <div style={{ width: '400px' }}>
                {
                  getFieldDecorator('startDate', {
                    rules: [{ required: true, message: '请选择开始时间', }],
                    initialValue: record.startDate && moment(record.startDate, 'YYYY-MM-DD HH:mm:ss') || null

                  })(
                    <WizDatePicker
                      key='startDate' showTime
                      format={dateFormat}
                      placeholder={['请选择开始时间']}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: '结束时间',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <div style={{ width: '400px' }}>
                {
                  getFieldDecorator('endDate', {
                    rules: [{ required: true, message: '请选择结束时间', }],
                    initialValue: record.endDate && moment(record.endDate, 'YYYY-MM-DD HH:mm:ss') || null
                  })(
                    <WizDatePicker
                      key='endDate' showTime
                      format={dateFormat}
                      placeholder={['请选择结束时间']}
                    />
                  )
                }
              </div>
            )
          }
        }
      },
      {
        title: '考试时长',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('limitMinutes', {
                      rules: [
                        { required: true, message: '请输入限制考试考试时长', },
                        { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                      ],
                      initialValue: record.limitMinutes
                    })(
                      <WizInputNumber min={1} max={9999} />
                    )
                  }
                </WizCol>
                <WizCol span={1} className='limit-minutes-text'>分钟</WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'考试用时到达后系统自动完成交卷'}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 3 }} />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '允许重复考试',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <WizRow>
                <WizCol span={4}>
                  {
                    getFieldDecorator('count', {
                      rules: [
                        { required: true, message: "请输入允许重复考试次数" },
                        { pattern: /^[0-9]{1,4}$/, message: "限制最大输入4位数" }
                      ],
                      initialValue: record.count
                    })(
                      <WizInputNumber min={0} max={9999} />
                    )
                  }
                </WizCol>
                <WizCol span={1} className='limit-minutes-text'>次</WizCol>
                <WizCol span={1}>
                  <WizTooltip title={'允许考生多次参与考试，0次则不限制次数。'}>
                    <WizIcon type='question-circle-o' style={{ marginLeft: 10 }} />
                  </WizTooltip>
                </WizCol>
              </WizRow>
            )
          }
        }
      },
      {
        title: '上传封面',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {getFieldDecorator('questionImg', {
                  initialValue: (record && record.img) ? [
                    { fileId: record.img }
                  ] : [],
                })(
                  <WizAvatarUpload
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    aspectRatio={400 / 207}
                    beforeUpload={(file) => {
                      const isLt1M = file.size / 1024 / 1024 < 1;
                      if (!isLt1M) {
                        Wizmessage.error('图片不得超过1MB!');
                      }
                      return isLt1M;
                    }}
                  />
                )}
              </>
            )
          }
        }
      },
      {
        title: '介绍',
        name: 'intro',
        dataIndex: 'intro',
        formItem: {
          type: 'textarea',
          placeholder: '选填，请提供简介内容，方便大家了解此考试',
          maxLength: 200,
          initialValue: undefined
        },
      },
      {
        title: '防作弊限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldValue, getFieldDecorator, setFieldsValue } = form
            return (
              <>
                {this._renderCheckRow('shuffle', getFieldDecorator)}
                {this._renderCheckRow('optionRandom', getFieldDecorator)}
                {this._renderCheckRowFace('face', getFieldDecorator)}
                {this._renderFaceAuth(form)}
              </>
            )
          }
        }
      },
      {
        title: '批阅限制',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            return (
              <>
                {this._renderCheckRow('autoMark', getFieldDecorator)}
                {this._renderContainsSubjective(form)}
                {this._renderTeacherList(form)}
                {this._renderCheckRow('showScore', getFieldDecorator)}
                {this._renderCheckRow('showResult', getFieldDecorator)}
                {this._renderCheckRow('showHistory', getFieldDecorator)}
                {this._renderCheckRow('showAnswer', getFieldDecorator)}
                {this._renderCheckRow('resolve', getFieldDecorator)}
              </>
            )
          }
        }
      }
    ]
  }

  _onReset() {
    this.refs.form && this.refs.form.resetFields && this.refs.form.resetFields()
    this.resetTime = new Date().getTime()
  }

  _fitterExamValues(values) {
    let fitterValues = {}
    Object.keys(values).forEach(key => {
      let value = values[key]
      if (value !== null && value !== undefined && value !== '' && value !== 'null') {
        fitterValues[key] = value
      } else {
        if (!fitterValues['containsSubjective']) {
          fitterValues['containsSubjective'] = 1
        }
      }
    })

    Object.keys(this.checks).forEach(key => {
      fitterValues[key] = fitterValues[key] ? 1 : 0
    })
    fitterValues.categoryTypeId = fitterValues.categoryTypeId

    fitterValues['startDate'] = fitterValues['startDate'] && fitterValues['startDate'].format('YYYY-MM-DD HH:mm:ss')
    fitterValues['endDate'] = fitterValues['endDate'] && fitterValues['endDate'].format('YYYY-MM-DD HH:mm:ss')
    /**
     * 图片参数处理
     */
    let questionImg = fitterValues['questionImg']
    if (questionImg && questionImg.length) {
      fitterValues['img'] = questionImg[0]['fileId']
      delete fitterValues['questionImg']
    }

    // 批阅人 保存时需要重置record, 如果选择的有批阅人,需要将teacherList加入
    let personIds = values.personIds
    if (personIds) {
      fitterValues['teacherList'] = personIds.map(e => {
        return { personId: e }
      })
    }
    return fitterValues
  }

  _onSave(nextStep) {
    const { record, totalScore } = this.state
    const { status } = record
    let form = this.refs.form
    if (form) {
      form.validateFields((err, values) => {
        let imgFile = values.questionImg && values.questionImg.length ? values.questionImg[0] : ''
        if (!err) {
          let params = this._fitterExamValues(values)
          params.status = 0
          params.fileMimeType = imgFile.fileType
          params.fileName = imgFile.name
          params.fileSize = imgFile.size
          params.fileUri = imgFile.sysUrl

          this.setState({ nextStep, record: params }, () => {
            if (this.copyExam) {
              params.pathUrl = 'exam/createExam'
              this.doAction({
                path: 'exam/createExam',
                payload: {
                  key: 'exam@copy',
                  apiParams: { ...params }
                }
              })
            } else if (this._examId && this._type != "temp") {
              params.status = status || 0
              params.pathUrl = 'exam/updateExam'
              this.doAction({
                path: 'exam/updateExam',
                payload: {
                  key: 'exam@update',
                  apiParams: { id: this._examId, ...params, totalScore: totalScore }
                }
              })
            } else {
              params.type = this._type
              params.pathUrl = 'exam/createExam'
              this.doAction({
                path: 'exam/createExam',
                payload: {
                  key: 'exam@create',
                  apiParams: { pathUrl: 'exam/createExam', ...params }
                }
              })
            }
          })
        } else {
          if (err) {
            const { spaceTime, authenticationCount } = err;
            if (spaceTime && spaceTime.errors && spaceTime.errors instanceof Array && spaceTime.errors.length > 0) {
              const { message, field } = spaceTime.errors[0];
              form.setFields({
                'spaceTime': {
                  value: values['spaceTime'],
                  errors: [
                    new Error(message)
                  ]
                }
              });
            }
            if (authenticationCount && authenticationCount.errors && authenticationCount.errors instanceof Array && authenticationCount.errors.length > 0) {
              const { message, field } = authenticationCount.errors[0];
              form.setFields({
                'authenticationCount': {
                  value: values['authenticationCount'],
                  errors: [
                    new Error(message)
                  ]
                }
              });
            }
          }
        }
      })
    }
  }

  _renderFooter = () => {
    return (
      <WizRow className='form-btns col-item'>
        <WizCol span={24}>
          <WizButton title='下一步' type='primary' htmlType='submit' onClick={e => this._onSave(true)}>保存并进入下一步</WizButton>
          <WizButton title='保存' htmlType='submit' onClick={e => this._onSave(false)}>保存并返回</WizButton>
          <WizButton title='重置' onClick={e => this._onReset()}>重置</WizButton>
        </WizCol>
      </WizRow>
    )
  }

  _render() {
    let columns = this._columns();
    let record = this.state.record;
    let formProps = {
      ref: 'form',
      columns,
      record: this.state.record,
      preview: null,
      footer: this._renderFooter(),
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      }
    }
    let wizCustomStepsProps = {
      header: [
        { title: '考试信息' },
        { title: '考试章节' },
        { title: '受众设置' }
      ],
      current: 0,
      content: <WizForm {...formProps} />,
      footer: null
    }
    return <WizCustomSteps {...wizCustomStepsProps} />
  }

  propsAndStateOnChange = {
    createExam: this._createExamOnChange.bind(this),
    updateExam: this._updateExamOnChange.bind(this),
    copyExam: this._copyExamOnChange.bind(this),
    examInfo: this._examInfo.bind(this),
  }

  _examInfo(nextProps, nextState) {
    if (nextProps.examInfo.code === 1) {
      let record = nextProps.examInfo.data
      nextState.record = record
    }
  }

  _createExamOnChange(nextProps, nextState) {
    if (nextProps.createExam.code === 1) {
      let examId = nextProps.createExam.data
      this._examId = examId
      nextState.record['id'] = examId
      this._nextPage(this.copyExam, this.state.nextStep)
      nextState.nextStep = false
    } else {
      wizNotice.error(nextProps.createExam && nextProps.createExam['msg'] || '操作失败,请稍后尝试')
      return false
    }
    return true
  }

  _copyExamOnChange(nextProps, nextState) {
    if (nextProps.copyExam.code === 1) {
      this._examId = nextProps.copyExam.data
      this._nextPage(this.copyExam, this.state.nextStep)
      nextState.nextStep = false
    } else {
      wizNotice.error(nextProps.copyExam && nextProps.copyExam['msg'] || '操作失败,请稍后尝试')
      return false
    }
    return true
  }

  _updateExamOnChange(nextProps, nextState) {
    if (nextProps.updateExam.code === 1) {
      this._nextPage(this.copyExam, this.state.nextStep)
      nextState.nextStep = false
    } else {
      wizNotice.error(nextProps.updateExam && nextProps.updateExam['msg'] || '操作失败,请稍后尝试')
      return false
    }
    return true
  }

  _nextPage(copyExam, nextStep) {
    if (nextStep) {
      this.jumpPage(
        'push',
        '/online/exam/examChapter',
        { ...this.state.record, id: this._examId, copyExam: copyExam, copyExamId: this._copyExamId }
      )
    } else {

      this.jumpPage(
        'push',
        '/online/exam',
      )
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  const { exam } = state
  const createExam = modelUtils.getModelEntity(exam, 'exam@create')
  const updateExam = modelUtils.getModelEntity(exam, 'exam@update')
  const copyExam = modelUtils.getModelEntity(exam, 'exam@copy')
  const load = modelUtils.getLoadingState(state, 'exam')
  return {
    createExam,
    updateExam,
    copyExam,
    ...load
  }
}

export default connect(mapStateToProps)(ExamDetail)
